import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 48px;
`;

const SectionTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 30px;
  margin-top: 20px;
  color: var(--text-color);
`;

const RefundContent = styled.div`
  line-height: 1.6;
  color: var(--text-color);
  margin-bottom: 120px;
  
  h2 {
    font-size: 1.8rem;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-top: 30px;
    margin-bottom: 15px;
  }
  
  p {
    margin-bottom: 20px;
  }
  
  ul {
    margin-bottom: 20px;
    padding-left: 20px;
    list-style-type: disc;
  }
  
  li {
    margin-bottom: 10px;
  }
`;

const RefundPage = () => {
    return (
        <PageContainer>
            <Container>
                <SectionTitle>Refund Policy</SectionTitle>

                <RefundContent>
                    <p>Effective Date: [Insert Date]</p>

                    <p>Thank you for shopping with Interstellar Map. We take pride in crafting personalized star maps that are scientifically accurate and emotionally meaningful. If you are not entirely satisfied with your purchase, we’re here to help.
                    </p>

                    <h2>1. Eligibility for Refunds</h2>
                    <p>You may request a refund within 14 days of receiving your order. To be eligible:</p>

                    <ul>
                        <li>The item must be unused and in the same condition that you received it</li>
                        <li>It must be in the original packaging (if applicable)</li>
                        <li>You must provide proof of purchase (e.g. order number or confirmation email)</li>
                    </ul>

                    <p>Digital Products (e.g. digital download star maps) are non-refundable unless:
                    </p>

                    <ul>
                        <li>The file is defective or corrupted</li>
                        <li>The file was not delivered to your email or download link after confirmation</li>
                    </ul>

                    <h2>2. How to Request a Refund</h2>
                    <p>
                    To request a refund, contact our support team at info@interstellarmap.com with:
                    </p>
                    <ul>
                        <li>Your order number</li>
                        <li>A brief description of the issue</li>
                        <li>Photos (if the item is damaged or defective)</li>
                    </ul>

                    <p>Our team will respond within 2–3 business days to assess your request.
                    </p>

                    <h2>3. Refund Process</h2>

                    <p>If your refund is approved:
                    </p>

                    <ul>
                        <li>For physical items: you may be required to return the product (return shipping details will be provided)</li>
                        <li>Refunds will be issued to your original method of payment within 7–10 business days</li>
                    </ul>

                    <p>We reserve the right to reject refund requests that do not meet the conditions stated above.
                    </p>

                    <h2>4. Exchanges & Replacements
                    </h2>
                    <p>
                    We do not offer direct exchanges. However, if your item is damaged or incorrect, we will gladly replace it free of charge. Please notify us within 7 days of delivery.
                    </p>

                    <h2>5. Shipping Costs
                    </h2>
                    <p>
                    Return shipping costs are the responsibility of the customer unless the product is defective or we sent the wrong item.
                    </p>

                    <h2>6. Contact Us
                    </h2>
                    <p>
                    If you have any questions about your order or this policy, please contact:
                    </p>
                    <ul>
                        <li>Email: info@interstellarmap.com</li>
                        <li>Website: https://interstellarmap.com</li>
                    </ul>
                </RefundContent>
            </Container>
        </PageContainer>
    );
};

export default RefundPage; 